import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { State, StateCreate, StateFilter } from '../data/state';

export function createStateService(client: AxiosInstance) {
  return createCrudService<State, StateCreate, StateFilter>(
    client,
    '/master-data/State',
    'id',
  );
}

export type StateService = CrudService<State, StateCreate, StateFilter>;
